// frontend/src/App.jsx

import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import EntryPoint from './views/EntryPoint';
import Invitations from './views/Invitations';
import Members from './views/Members';
import LoginForm from './views/LoginForm';
import AuthenticatedDashboard from './views/AuthenticatedDashboard';
import BaseLayout from './layouts/BaseLayout';
import MagicLinkHandler from './views/MagicLinkHandler';
import AccessHashHandler from './views/AccessHashHandler';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <BaseLayout />,
      children: [
        { path: '/', element: <EntryPoint /> },
        { path: '/invitations', element: <Invitations /> },
        { path: '/members', element: <Members /> },
        { path: '/login', element: <LoginForm /> },
        { path: '/authenticated', element: <AuthenticatedDashboard /> },
        // Ruta para manejar el enlace mágico
        { path: '/magiclink/:token', element: <MagicLinkHandler /> },
        { path: '/access/:hash', element: <AccessHashHandler /> },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;